import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { unixToDate } from '../../utils';
import gs from '../../global.css';
import s from './style.css';
import { auth } from '../../actions';
import { Button } from '../../components';
const SubCancelledScreen = (props) => {
    useEffect(() => {
        props.refreshUser();
    }, []);
    const history = useHistory();
    return (React.createElement("div", { className: gs.main },
        React.createElement("div", { className: `${gs.screenContainer} ${gs.centerScreen}` },
            React.createElement("div", { className: `${gs.box} ${s.container}` },
                React.createElement("p", { className: s.welcome }, "Subscription has been cancelled"),
                React.createElement("p", { className: s.text },
                    "Your premium benefits expire on: ",
                    unixToDate(props.expires),
                    ". Please be noted that data exceeding basic storage (1 GB) will be deleted 14 days after the expiration date.",
                    React.createElement("span", { className: s.text, style: { alignSelf: 'flex-start' } }, "We hope to see you back again!")),
                React.createElement(Button, { text: 'Back to My Vault', colored: true, onClick: () => history.replace('/vault/files') })))));
};
const mapStateToProps = (state) => ({
    expires: state.app.subscription.expires,
});
const connector = connect(mapStateToProps, { ...auth });
export default connector(SubCancelledScreen);
